module.exports = __webpack_public_path__ + "static/img/hezuo11.924fe97.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo11.jpg
// module id = grFZ
// module chunks = 1